import axios from 'axios';
import standAloneGet from '@/store/modules/stand-alone-service.js';

const state = {
     admin: false,
     standAlone: true,
     newUser: true,
     contestantId: null,
     gameStatus: {
         inProgress: false,
         buzzIn: null,
         contestants: { },
         pictures: { },
         pictureId: null
     },
};

const getters = {
    gameStatus: state => state.gameStatus,
    contestantId: state => state.contestantId,
    admin: state => state.admin,
    newUser: state => state.newUser,
};

const mutations = {
    updateGameStatus: (state, gameStatus) => {
        state.gameStatus = gameStatus;
        if (state.contestantId && !gameStatus.contestants[state.contestantId]) {
            state.contestantId = null;
            state.newUser = !state.admin;
        }
    },
    setContestantId: (state, contestantId) => (
        state.contestantId = contestantId
    ),
    setNewUser: (state, value) => (
        state.newUser = value
    ),
    setAdmin: (state, value) => {
      state.admin = value
    },
    setStandAlone: (state, value) => {
      state.standAlone = value
    },
};

const makeRequest = (state, request, payload) => {
    if (state.standAlone) {
        return standAloneGet(request, payload);
    }
    return axios.post(request, payload);
}

const actions = {
    async init({ commit }, params) {
        if (params.god) {
            commit('setAdmin', true);
            commit('setNewUser', false);
        }
        if (params.connected) {
            commit('setStandAlone', false);
        }
    },
    async toggleNewUser({ commit, state }) {
        commit('setNewUser', !state.newUser);
    },
    async setContestant({ commit }, id) {
        commit('setContestantId', id);
    },
    async getGameStatus({ commit, state }) {
        const response = await makeRequest(state, './api/status');
        commit('updateGameStatus', response.data);
    },
    async addContestant({ commit, state }, name) {
        const id = new Buffer(name).toString('base64');
        const response = await makeRequest(state, './api/addContestant', { id });
        commit('setContestantId', id);
        commit('setNewUser', false);
        commit('updateGameStatus', response.data);
    },
    async removeContestant({ commit, state }, id) {
        const response = await makeRequest(state, './api/removeContestant', { id });
        commit('updateGameStatus', response.data);
    },
    async addPoint({ commit, state }, id) {
        const response = await makeRequest(state, './api/addPoint', { id });
        commit('updateGameStatus', response.data);
    },
    async deductPoint({ commit, state }, id) {
        const response = await makeRequest(state, './api/deductPoint', { id });
        commit('updateGameStatus', response.data);
    },
    async buzzIn({ commit, state }) {
        const response = await makeRequest(state, './api/buzzIn', { id: state.contestantId });
        commit('updateGameStatus', response.data);
    },
    async reset({ commit, state }) {
        const response = await makeRequest(state, './api/reset');
        commit('updateGameStatus', response.data);
    },
    async start({ commit, state }) {
        const response = await makeRequest(state, './api/start');
        commit('updateGameStatus', response.data);
    },
    async stop({ commit, state }) {
        const response = await makeRequest(state, './api/stop');
        commit('updateGameStatus', response.data);
    },
    async buzzOut({ commit, state }) {
        const response = await makeRequest(state, './api/buzzOut');
        commit('updateGameStatus', response.data);
    },
    async setPicture({ commit }, id) {
        const response = await makeRequest(state, './api/setPicture', { id });
        commit('updateGameStatus', response.data);
    },

};

export default {
    state,
    getters,
    mutations,
    actions,
}